import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { StandardOS } from '../../models/calculator-models/standard-os.model';
import { StandardPremium } from '../../models/calculator-models/stamdard-premium.model';
import { AdutOS } from '../../models/calculator-models/adut-os.model';
import { AdutPermium } from '../../models/calculator-models/adut-premium.model';
import { SecurityOS } from 'src/app/shared/models/calculator-models/security-os.model';
import { SecurityPremium } from '../../models/calculator-models/security-premium.model';
import { SecurityCredit } from '../../models/calculator-models/security-credit.model';
import { ScholarshipOS } from '../../models/calculator-models/scholarship-os.model';
import { ScholarshipPremium } from '../../models/calculator-models/scholarship-premium';
import { GoldenAutumn } from '../../models/calculator-models/golden-autumn.model';
import { NajlifeOS } from '../../models/calculator-models/naj-life-os.model';
import { NajlifePremium } from '../../models/calculator-models/naj-life-premium.model';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CalculatorService {

    constructor(private httpClient: HttpClient) { }

    calculateStandartOS(standardOS: StandardOS) {
        return this.httpClient.post('api/calculator/standard', standardOS.data);
    }

    calculateStandardPremium(standardPremium: StandardPremium) {
        return this.httpClient.post('api/calculator/standardpremium', standardPremium.data)
    }

    calculateAdutOS(adutOS: AdutOS) {
        return this.httpClient.post('api/calculator/adut', adutOS.data);
    }

    calculateAdutPremium(adutPremium: AdutPermium) {
        return this.httpClient.post('api/calculator/adutpremium', adutPremium.data);
    }

    calculateSecurityOS(securityOS: SecurityOS) {
        return this.httpClient.post('api/calculator/risk', securityOS.data);
    }

    calculateSecurityPremium(securityPremium: SecurityPremium) {
        return this.httpClient.post('api/calculator/riskpremium', securityPremium.data);
    }

    calculateSecurityCredit(securityCredit: SecurityCredit) {
        return this.httpClient.post('api/calculator/credit', securityCredit.data);
    }

    calculateSecurityCash(securityCash: SecurityCredit) {
        return this.httpClient.post('api/calculator/cash', securityCash.data);
    }

    calculateScholarshipOS(scholarshipOS: ScholarshipOS) {
        return this.httpClient.post('api/calculator/grant', scholarshipOS.data);
    }

    calculateScholarshipPremium(scholarshipPremium: ScholarshipPremium) {
        return this.httpClient.post('api/calculator/grantpremium', scholarshipPremium.data)
    }

    calculateGoldenAutumn(goldenAutumn: GoldenAutumn) {
        return this.httpClient.post('api/calculator/zj', goldenAutumn.data);
    }

    calculateNajlifeOS(najlifeOS: NajlifeOS){
        return this.httpClient.post('api/calculator/najlife', najlifeOS.data)
        .pipe(
            map((res: any) => {
                return res;
            }),
            catchError((error) => {
                return throwError(error);
            })
        );
    }

    calculateNajlifePremium(najlifePremium: NajlifePremium){
        return this.httpClient.post('api/calculator/najlifepremium', najlifePremium.data);
    }

    calculateProgresive(progresive: any){
        return this.httpClient.post('api/calculator/progressive', progresive).toPromise()
    }

}